import { getEmissionsFaktor } from '../../../main/functions/getEmmissionsFaktor';
import { IDs } from '../../../helpers/IDs';

export function getValuesKWH(kennzahlen: any[], data: any, jahr: number, energietraeger: string): any {
    let faktor_co2 = getEmissionsFaktor(data, '', jahr, getCO2name(data, energietraeger));
    /*if (energietraeger === 'fernwaerme') {
       console.log('faktor_co2', energietraeger, faktor_co2, kennzahlen[jahr]['faktor_co2_' + energietraeger]);
    }*/

    if (['andere', 'fernkaelte', 'fernwaerme', 'strom'].indexOf(energietraeger) !== -1
        && ((kennzahlen[jahr] || {})[`faktor_co2_${energietraeger}`] > 0 || (kennzahlen[jahr] || {})[`faktor_co2_${energietraeger}`] === 0)
    ) {
        faktor_co2 = kennzahlen[jahr][`faktor_co2_${energietraeger}`];
    } else if (energietraeger === 'strom' && kennzahlen[jahr]
        && ((kennzahlen[jahr] || {}).faktor_strom_co2 || (kennzahlen[jahr] || {}).faktor_strom_co2 === 0)
    ) {
        faktor_co2 = kennzahlen[jahr].faktor_strom_co2;
    }
    const verbrauch_kwh = (kennzahlen[jahr] || {})[`verbrauch_waerme_${energietraeger}_kwh`]
        ? kennzahlen[jahr][`verbrauch_waerme_${energietraeger}_kwh`]
        : 0;
    const verbrauch_kwh_base = (kennzahlen[jahr] || {})[`verbrauch_waerme_${energietraeger}_kwh_base`]
        ? kennzahlen[jahr][`verbrauch_waerme_${energietraeger}_kwh_base`]
        : 0;
    const kosten = (kennzahlen[jahr] || {})[`kosten_waerme_${energietraeger}`]
        ? kennzahlen[jahr][`kosten_waerme_${energietraeger}`]
        : 0;
    const co2 = ((kennzahlen[jahr] || {})[`co2_waerme_${energietraeger}`] || (kennzahlen[jahr] || {})[`co2_waerme_${energietraeger}`] === 0)
        ? kennzahlen[jahr][`co2_waerme_${energietraeger}`]
        : verbrauch_kwh * faktor_co2;
    const co2faktor = ((kennzahlen[jahr] || {})[`co2_waerme_${energietraeger}`] || (kennzahlen[jahr] || {})[`co2_waerme_${energietraeger}`] === 0)
        ? (kennzahlen[jahr][`co2_waerme_${energietraeger}`] / verbrauch_kwh_base)
        : faktor_co2;
    const verbrauch_prozess_kwh = (kennzahlen[jahr] || {})[`verbrauch_waerme_prozess_${energietraeger}_kwh`]
        ? kennzahlen[jahr][`verbrauch_waerme_prozess_${energietraeger}_kwh`]
        : 0;
    const messsystem = (kennzahlen[jahr] || {})['waerme_' + energietraeger + '_messsystem']
        ? kennzahlen[jahr][`waerme_${energietraeger}_messsystem`]
        : '';
    const kalibrierung = (kennzahlen[jahr] || {})[`waerme_${energietraeger}_kalibrierung`]
        ? kennzahlen[jahr][`waerme_${energietraeger}_kalibrierung`]
        : '';
    const heizwaerme = verbrauch_kwh - verbrauch_prozess_kwh;
    const heizwaerme_proz = (100 / verbrauch_kwh) * heizwaerme;

    return {
        verbrauch_menge: 0, verbrauch_kwh, co2, co2faktor, kosten, heizwaerme, heizwaerme_proz, messsystem, kalibrierung, verbrauch_kwh_base
    };
}

function getCO2name(data: any, energietraeger: string) {
    const energietraeger_list = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER];
    // console.log('ET!!', energietraeger, energietraeger_list);
    const energietraeger_obj = energietraeger_list.find((et: any) => et.id === energietraeger);
    return energietraeger_obj ? energietraeger_obj.co2_faktor : undefined;
}
